/**
 * Session Store
 *
 * Manages authentication session state globally.
 * When session expires (401 response), triggers PIN re-entry without page reload.
 */

import { create } from 'zustand';

interface SessionState {
  isAuthenticated: boolean;
  isLoading: boolean;
  sessionExpiredAt: number | null;

  // Actions
  setAuthenticated: (authenticated: boolean) => void;
  setLoading: (loading: boolean) => void;
  handleSessionExpired: () => void;
  resetSession: () => void;
}

export const useSessionStore = create<SessionState>((set, get) => ({
  // TEMPORARILY SET TO TRUE FOR DEBUGGING
  isAuthenticated: true,
  isLoading: false,
  sessionExpiredAt: null,

  setAuthenticated: (authenticated) => {
    set({ isAuthenticated: authenticated, sessionExpiredAt: null });
  },

  setLoading: (loading) => {
    set({ isLoading: loading });
  },

  handleSessionExpired: () => {
    const current = get();
    // Only trigger if we were previously authenticated
    if (current.isAuthenticated) {
      console.warn('[Session] Session expired - redirecting to PIN');
      set({
        isAuthenticated: false,
        sessionExpiredAt: Date.now(),
      });
    }
  },

  resetSession: () => {
    set({
      isAuthenticated: false,
      isLoading: false,
      sessionExpiredAt: null,
    });
  },
}));

/**
 * Call this from api.ts when a 401 is received
 */
export function handleUnauthorized(): void {
  useSessionStore.getState().handleSessionExpired();
}
